import React, { useState, useEffect } from "react";
import checkMarkGreen from "../../images/CheckmarkGreen.svg";
import expandIcon from '../../images/right_arrow.svg';
import "./ToolBarLeftPanel.scss";
import dropDownIcon from "../../images/expandDropDown.svg";
import warning from "../../images/infoIcon.svg";

import BuisnessRuleCard from "./BuisnessRuleCard";
const ModuleCard = ({
  card,
  setSelectedModule,

  handleExpandModuleClaims,
  sendAtomDetails2Canvas,
  handleGetChildModules,
  associatedCards,
  activeTab
}) => {
  const [isExpand, setIsExpand] = useState(false);
  const [isChildMoudleExist, setIsChildMoudleExist] = useState(false);

  // const handleGetChildModules = (moduleId) => {
   
    
  //   getChildModules(moduleId, (response, err, errorCode) => {
  //     if (err) {
  //       const errCoponent = errComponentToRender(errorCode);
  //       categoriesErr(errCoponent);
      
  //       setNoBussinessRules(false);
  //     } else {
  //       const businessRules = response?.data?.businessRules;
  //       let noData = response?.data?.businessRules.length > 0 ? false : true;
  //       setNoBussinessRules(noData);
  //       if (!businessRules) {
  //         setLoadingModules(false);
  //         return;
  //       }
  //       const optionalModules = [];
  //       const mustExistWithModules = [];
 
  //       businessRules.forEach((rule) => {
  //         switch (rule.ruleCondition) {
  //           case "Optional":
  //             if (Array.isArray(rule.targetModules)) {
  //               rule.targetModules.forEach((module) => {
  //                 optionalModules.push({
  //                   ...module,
  //                   ruleCondition: rule.ruleCondition,
  //                 });
  //               });
  //             }
  //             break;
  //           case "MustExistWith":
  //             rule.targetModules.forEach((module) => {
  //               mustExistWithModules.push({
  //                 ...module,
  //                 ruleCondition: rule.ruleCondition,
  //               });
  //             });
  //             break;
 
  //           default:
  //             break;
  //         }
  //       });
  //       setAssociatedCards(prevState => ({
  //         ...prevState,
  //         [moduleId]: { optionalModules, mustExistWithModules}
  //       }));
  //       setLoadingModules(false);
  //     }
  //   });
  // };

useEffect(() => {
  setIsExpand(false);
}, [activeTab]);

  useEffect(() => {
    if (
      associatedCards[card?.content_module_response?.id]?.optionalModules?.length === 0 &&
      associatedCards[card?.content_module_response?.id]?.mustExistWithModules?.length === 0
    ) {
      setIsChildMoudleExist(false);
    } else {
      setIsChildMoudleExist(true);
    }
  }, [
    associatedCards[card?.content_module_response?.id]?.optionalModules,
    associatedCards[card?.content_module_response?.id]?.mustExistWithModules,
  ]);

  return (
    <>
      <div className="module-cards-container mb-3 custonScrollBar ">
        <div
          className="selected-module-cards"
          onClick={() => {
            setSelectedModule(card, "childModule");
            handleExpandModuleClaims(card, "parentModule");
          }}
        >
          <div className="moduleCardFirstRow">
            <div className="cardInfoLeftSide">
              <img src={checkMarkGreen} className="checkMarkClass" />
              <strong className="boldText">{card?.content_module_response?.moduleDamName}</strong>
            </div>
            <div className="cardInfoRightSide">
              <div className="parentModulebox"></div>
              <div className="parentModuleText">Parent Module</div>
              <img
                src={expandIcon}
                onClick={() => {
                  setSelectedModule(card, "childModule");
                  handleExpandModuleClaims(card, "parentModule");
                }}
                className="expandIcon-module"
              />
            </div>
          </div>
          <div className="moduleCardsRow">
            <div className="infoText">Product :</div>
            {/* <div className="colonClass">:</div> */}
            <span className="nameBrandText module_card_nameBrandText">
              {""}
              {card?.content_module_response?.productName}
            </span>
          </div>
          <div className="moduleCardsRow">
            <div className="infoText">Name : </div>
            {/* <div className="colonClass">:</div> */}
            <span className="nameBrandText module_card_nameBrandText">
              {""}
              {card?.content_module_response?.moduleName}
            </span>
          </div>
        </div>
        <div
          className="modulesbuissRules"
        >
          <div
            className="d-flex align-items-center"
            onClick={() => {
              setIsExpand(!isExpand);
              if (!isExpand) {
                if (associatedCards[card?.content_module_response.id] === undefined) {
                  handleGetChildModules(card?.content_module_response.id);
                }
              }
            }}
          >
            <div className="buisnessRulesText">
              See Modules associated via Business Rules
            </div>
            <img
              onClick={() => {
                setIsExpand(!isExpand);
                if (!isExpand) {

                  if (associatedCards[card?.content_module_response.id] === undefined) {
                    handleGetChildModules(card?.content_module_response.id);
                  }
                }
              }}
              style={{
                cursor: "pointer",
                height: isExpand ? "5px" : "",
                width: isExpand ? "8px" : "",
                position: "relative",
              }}
              src={!isExpand ? expandIcon : dropDownIcon}
            />
          </div>
          {(!isChildMoudleExist && isExpand)&& <div className="d-flex no-module-found">
            <img src={warning} alt="" className="img-fluid mr-1" />
            No modules found
          </div>}
        </div>
        {/* { isExpand &&(
        <div className="associated-cards">
          {associatedCards?.map((cardObj) => {
            return <BuisnessRuleCard cardObj={cardObj} sendAtomDetails2Canvas={sendAtomDetails2Canvas}/>;
          })}
        </div>
        ) } */}
        {isExpand && (
          <div className="associated-cards">
            {isChildMoudleExist ? (
              <>
                {associatedCards[card?.content_module_response?.id]?.optionalModules?.map(
                  (cardObj) => {
                    return (
                      <BuisnessRuleCard
                        key={cardObj.targetModuleId}
                        cardObj={cardObj}
                        sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                        handleExpandModuleClaims={handleExpandModuleClaims}
                        setSelectedModule={setSelectedModule}
                      />
                    );
                  }
                )}
                {associatedCards[card?.content_module_response?.id]?.mustExistWithModules?.map(
                  (cardObj) => {
                    return (
                      <BuisnessRuleCard
                        key={cardObj.targetModuleId}
                        cardObj={cardObj}
                        sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                        handleExpandModuleClaims={handleExpandModuleClaims}
                        setSelectedModule={setSelectedModule}
                      />
                    );
                  }
                )}
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ModuleCard;
